import React, { useEffect, useState } from 'react';
import { Button } from 'modules/v2/common/AtomicDesign/atoms';

interface ReactivationInstructionsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ReactivationInstructionsModal: React.FC<ReactivationInstructionsModalProps> = ({
  isOpen,
  onClose,
}) => {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    // Reset to first step when modal opens
    if (isOpen) {
      setCurrentStep(0);
    }
  }, [isOpen]);

  const handleClose = () => {
    setCurrentStep(0);
    onClose();
  };

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      handleClose();
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  if (!isOpen) return null;

  const steps = [
    {
      number: 1,
      text: 'Click on your subscription card (the white card showing your plan price)',
      image: '/images/self-01.png',
    },
    {
      number: 2,
      text: "Click the 'Remove Scheduled Cancellation' button",
      image: '/images/self-02.png',
    },
    {
      number: 3,
      text: "Click 'Confirm' to complete the reactivation",
      image: '/images/self-03.png',
    },
  ];

  const currentStepData = steps[currentStep];
  const isLastStep = currentStep === steps.length - 1;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={handleClose}
    >
      <div
        className="bg-white rounded-lg max-w-lg w-full shadow-xl max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="px-4 pt-4 pb-3 sm:px-6 sm:pt-6 sm:pb-4">
          <div className="flex items-center justify-between mb-1">
            <h2 className="text-base sm:text-lg font-semibold text-neutral-800">
              How to reactivate my subscription?
            </h2>
            <span className="text-xs text-gray-500 font-medium">
              {currentStep + 1} / {steps.length}
            </span>
          </div>
        </div>

        {/* Step Content */}
        <div className="px-4 pb-4 sm:px-6 sm:pb-6">
          <p className="text-sm sm:text-base text-neutral-700 mb-3 sm:mb-4">{currentStepData.text}</p>
          <img
            src={currentStepData.image}
            alt={`Step ${currentStepData.number}`}
            className="w-[70%] mx-auto rounded-lg border border-gray-200 shadow-sm"
          />
        </div>

        {/* Footer */}
        <div className="bg-gray-50 px-6 py-4 rounded-b-lg">
          <div className="flex items-center justify-end gap-2">
            {currentStep > 0 && (
              <button
                onClick={handleBack}
                className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-200 rounded transition-colors"
              >
                Back
              </button>
            )}
            <Button type="primary" onClick={handleNext}>
              {isLastStep ? 'Got it' : 'Next'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReactivationInstructionsModal;
